import React from 'react';

const ProductOverview = () => {
  return (
    <section className="section light" id="product-overview">
      <h2 className="section-title">What is MICRO 24?</h2>
      <p className="section-subtitle">
        MICRO 24 is an industrial-grade fuel additive that works at the micro level
        of each droplet – helping legacy boilers and furnaces burn cleaner, run
        steadier and consume less fuel.
      </p>

      <div className="cards">
        {/* Existing cards */}
        <div className="card">
          <h3>Efficiency</h3>
          <p>
            Micro-scale surfactants increase the number of fuel droplets and
            decrease their size, giving a greater surface area for cleaner and
            faster combustion.
          </p>
        </div>

        <div className="card">
          <h3>Cost Savings</h3>
          <p>
            More complete combustion means more energy released from each litre of
            fuel, reducing consumption and lowering your operating costs.
          </p>
        </div>

        <div className="card">
          <h3>Clean Energy</h3>
          <p>
            MICRO 24 significantly cuts soot, smoke and residue for cleaner
            emissions and greener operations – good for your business and the
            environment.
          </p>
        </div>

        {/* New cards */}
        <div className="card">
          <h3>Faster Start-Up</h3>
          <p>
            Reduces light-up time at power stations by stabilizing combustion
            faster, enabling quicker start-ups and improved operational
            responsiveness.
          </p>
        </div>

        <div className="card">
          <h3>Lower Maintenance</h3>
          <p>
            Keeps fuel guns, burners, and nozzles carbon-free, reducing fouling,
            maintenance frequency, and extending the service life of critical
            components.
          </p>
        </div>

        <div className="card">
          <h3>Worker Safety & Emissions</h3>
          <p>
            Promotes complete combustion to reduce harmful gases, fumes, and
            unburnt hydrocarbons—lowering carbon footprint and health risks to
            operating personnel.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProductOverview;
